'use strict'

# Source: http://emailregex.com/
emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

module.exports =
  isEmail: (email) ->
    emailReg.test email



// WEBPACK FOOTER //
// ./src/frontend/helper/validator.coffee